// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__bZiOr","header":"MergedInvoice_header__Mygac"};